import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import {ModalProgressBar} from "../ModalProgressBar";
import {shallowEqual, useSelector} from "react-redux";

export function EditDialogHeader({ id, item, name='' }) {

  const [title, setTitle] = useState("");

  // Title counting
  useEffect(() => {
    let _title = id ? "" : `${item} جدید `;
    if (id !== 0) {
      _title = `ویرایش ${item} ${name}`;
    }
    setTitle(_title);
  }, [title]);

  const {actionsLoading} = useSelector(
      (state) => ({
        actionsLoading: state.actionsLoading.actionsLoading,
      }),
      shallowEqual
  );

  return (
    <>
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
